// ============================================================
// Rabatt-Bestaetigung als mittige Karte — 1InstaPhone Shop-Theme
//
// WAS ES TUT: Wer ueber einen Rabattlink kommt
// (https://1instaphone.com/discount/CODE?redirect=...), sieht in der
// Bildschirmmitte kurz eine Karte: "Dein Rabattcode CODE ist aktiviert,
// wird an der Kasse automatisch abgezogen."
// Nach 6 Sekunden blendet sie sich von selbst wieder aus. Einmal je
// Sitzung. Gilt fuer JEDEN per Link aktivierten Code.
//
// ZWEITE AUFGABE: Solange ein Code in der Sitzung liegt, wird das
// Klaviyo-Gluecksrad (Formular YwujVD) zurueckgehalten. Ohne Code
// bleibt das Rad voellig unveraendert.
//
// WAS ES NICHT PRUEFEN KANN: ob der Code gueltig ist. Shopify legt jeden
// Code aus dem Link in die Sitzung, auch einen erfundenen oder
// abgelaufenen. Deshalb betrieblich: nie einen toten Code in einen Link.
//
// EINBAU: assets/bf-rabatt-streifen.js, geladen in layout/theme.liquid
// vor dem schliessenden body-Tag:
//   <script src="{{ 'bf-rabatt-streifen.js' | asset_url }}" defer>
// ============================================================

(function () {
  'use strict';

  var ANZEIGEDAUER_MS = 6000;      // wie lange die Karte steht
  var SITZUNGS_SCHLUESSEL = 'bf_rabatt_streifen_gezeigt';

  function codeAusCookie() {
    var treffer = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!treffer) return null;
    try {
      var wert = decodeURIComponent(treffer[1]).trim();
      // Nur plausible Codes: Buchstaben, Ziffern, Bindestrich, Unterstrich.
      return /^[A-Za-z0-9_-]{2,40}$/.test(wert) ? wert : null;
    } catch (e) {
      return null;
    }
  }

  function schonGezeigt() {
    try { return sessionStorage.getItem(SITZUNGS_SCHLUESSEL) === '1'; }
    catch (e) { return false; }   // privates Fenster: dann eben jedes Mal
  }

  function alsGezeigtMerken() {
    try { sessionStorage.setItem(SITZUNGS_SCHLUESSEL, '1'); } catch (e) {}
  }

  function bauen(code) {
    var leiste = document.createElement('div');
    leiste.id = 'bf-rabatt-streifen';
    leiste.setAttribute('role', 'status');
    leiste.setAttribute('aria-live', 'polite');
    leiste.innerHTML =
      '<div class="bf-rs-karte" role="dialog" aria-label="Rabattcode aktiviert">' +
        '<button type="button" class="bf-rs-zu" aria-label="Hinweis schliessen">&times;</button>' +
        '<span class="bf-rs-haken" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="34" height="34">' +
          '<circle cx="12" cy="12" r="11" fill="none" stroke="currentColor" stroke-width="1.6" opacity=".35"/>' +
          '<path d="M6.5 12.4l3.7 3.7L17.6 8" fill="none" stroke="currentColor" ' +
          'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<p class="bf-rs-titel">Dein Rabattcode ist aktiviert</p>' +
        '<p class="bf-rs-code-zeile"><b class="bf-rs-code"></b></p>' +
        '<p class="bf-rs-zusatz">Wird an der Kasse automatisch abgezogen.</p>' +
      '</div>';

    // Code als Text setzen, nicht in den HTML-String kleben.
    leiste.querySelector('.bf-rs-code').textContent = code;

    var stil = document.createElement('style');
    stil.textContent = [
      '#bf-rabatt-streifen{position:fixed;inset:0;z-index:2147483000;',
      'display:flex;align-items:center;justify-content:center;',
      'pointer-events:none;padding:16px;font-family:inherit;',
      'opacity:0;transition:opacity .3s ease;}',
      '#bf-rabatt-streifen.bf-rs-an{opacity:1;}',
      '.bf-rs-karte{pointer-events:auto;position:relative;box-sizing:border-box;',
      'width:100%;max-width:340px;background:#1a7a2c;color:#fff;',
      'border-radius:16px;padding:26px 22px 22px;text-align:center;',
      'box-shadow:0 18px 50px rgba(0,0,0,.32);',
      'transform:scale(.92);transition:transform .3s ease;}',
      '#bf-rabatt-streifen.bf-rs-an .bf-rs-karte{transform:scale(1);}',
      '.bf-rs-haken{display:block;margin:0 auto 10px;line-height:0;}',
      '.bf-rs-titel{margin:0 0 10px;font-size:17px;font-weight:600;line-height:1.3;}',
      '.bf-rs-code-zeile{margin:0 0 12px;}',
      '.bf-rs-code{display:inline-block;background:rgba(255,255,255,.16);',
      'border:1px dashed rgba(255,255,255,.55);border-radius:8px;',
      'padding:7px 16px;font-size:20px;font-weight:700;letter-spacing:.06em;}',
      '.bf-rs-zusatz{margin:0;font-size:13.5px;opacity:.85;line-height:1.4;}',
      '.bf-rs-zu{position:absolute;right:6px;top:4px;background:none;border:0;',
      'color:#fff;font-size:26px;line-height:1;padding:4px 10px;cursor:pointer;opacity:.7;}',
      '.bf-rs-zu:hover{opacity:1;}',
      '@media (prefers-reduced-motion:reduce){#bf-rabatt-streifen,',
      '#bf-rabatt-streifen .bf-rs-karte{transition:none;}}'
    ].join('');

    document.head.appendChild(stil);
    document.body.appendChild(leiste);

    var weg = function () {
      leiste.classList.remove('bf-rs-an');
      setTimeout(function () {
        if (leiste.parentNode) leiste.parentNode.removeChild(leiste);
      }, 400);
    };

    leiste.querySelector('.bf-rs-zu').addEventListener('click', weg);
    leiste.addEventListener('click', function (e) { if (e.target === leiste) weg(); });
    // Einblenden ueber setTimeout, nicht ueber requestAnimationFrame:
    // rAF feuert nicht in jedem Umfeld und die Karte bliebe unsichtbar.
    setTimeout(function () { leiste.classList.add('bf-rs-an'); }, 30);
    setTimeout(weg, ANZEIGEDAUER_MS);
  }

  // --------------------------------------------------------------
  // Gluecksrad zurueckhalten, solange ein Rabattcode in der Sitzung liegt
  //
  // Warum: Wer ueber einen Rabattlink kommt, hat schon einen Code. Das Rad
  // wuerde ihm daneben einen zweiten, meist schlechteren anbieten (bis zu
  // 20 Prozent gegen unsere 30) und sich ueber die Karte legen.
  // Ohne Code passiert hier nichts.
  //
  // Warum im Theme und nicht in Klaviyo: Klaviyos Zielsteuerung kennt keine
  // Bedingung auf ein Cookie (25.09.2026 geprueft). Klaviyo empfiehlt dafuer
  // selbst eigenes JavaScript in der Seite.
  //
  // Es wird NUR das Gluecksrad zurueckgehalten (YwujVD), keine anderen
  // Klaviyo-Formulare.
  // --------------------------------------------------------------
  var RAD_FORMULAR_ID = 'YwujVD';

  function radZurueckhalten() {
    // Wo das Rad wirklich haengt (25.09.2026 am echten Seitenaufbau
    // abgelesen, zwei Fehlversuche vorher):
    //   <div ...>                                  <- Ueberlagerung
    //     <div data-testid="modal-form-container">
    //       <form data-testid="klaviyo-form-YwujVD" class="klaviyo-form ...">
    //
    // Die Kennung des sichtbaren Fensters steht NUR im data-testid, weder
    // als id noch als Klasse.
    var ZIEL = 'form[data-testid="klaviyo-form-' + RAD_FORMULAR_ID + '"]';

    // Was als Shop-Inhalt gilt. Steckt eines davon in dem Knoten, den wir
    // ausblenden wollen, haben wir zu weit gegriffen.
    var SHOP_INHALT = '#main, .shopify-section, header, footer';

    var stil = document.createElement('style');
    stil.id = 'bf-rad-aus';
    stil.textContent = [
      // Schneller Weg gegen ein kurzes Aufblitzen. Das :not(:has(...)) ist
      // die Sperre: liegt in dem Container auch Shop-Inhalt, greift die
      // Regel NICHT. Ohne sie verschwaende bei einem eingebetteten Rad der
      // ganze Seiten-Wrapper - im eigenen Test genau so passiert.
      'body > div:has(' + ZIEL + '):not(:has(' + SHOP_INHALT + '))',
      '{display:none !important;}',
      // Rueckfallebene ohne :has(): wenigstens das Formular selbst.
      ZIEL + '{display:none !important;}',
      // Moeglicher Ankerpunkt, falls das Rad doch dort landet.
      '#klaviyo-form-' + RAD_FORMULAR_ID + '{display:none !important;}'
    ].join('');
    (document.head || document.documentElement).appendChild(stil);

    function wegnehmen() {
      var formular = document.querySelector(ZIEL);
      if (!formular) return false;

      // Vom Formular hoch bis direkt unter body, aber nur solange der
      // Knoten NICHTS vom Shop enthaelt. Sonst wuerde im schlimmsten Fall
      // die ganze Produktseite verschwinden, und zwar still und genau bei
      // den Besuchern aus den Rabatt-Anzeigen. security-sven, 25.09.2026.
      // Der Knoten SELBST zaehlt auch: querySelector sieht nur Nachfahren,
      // eine .shopify-section wuerde sich sonst selbst wegblenden.
      function istShopInhalt(el) {
        try {
          if (el.matches && el.matches(SHOP_INHALT)) return true;
        } catch (fehler) {}
        return !!el.querySelector(SHOP_INHALT);
      }

      var knoten = formular;
      while (knoten.parentElement && knoten.parentElement !== document.body) {
        var naechster = knoten.parentElement;
        if (istShopInhalt(naechster)) break;
        knoten = naechster;
      }

      if (knoten !== formular && istShopInhalt(knoten)) {
        knoten = formular;
      }

      knoten.style.setProperty('display', 'none', 'important');
      return true;
    }

    if (!wegnehmen() && window.MutationObserver) {
      var beobachter = new MutationObserver(function () {
        if (wegnehmen()) beobachter.disconnect();
      });
      beobachter.observe(document.documentElement, { childList: true, subtree: true });
      // Nicht ewig beobachten.
      setTimeout(function () { beobachter.disconnect(); }, 60000);
    }

    // Dritter Weg: Klaviyos eigenes Ereignis.
    //
    // Bewusst NUR ausblenden, NICHT Klaviyos Schliessen-Knopf klicken. Ein
    // Klick wuerde Klaviyo ein "vom Nutzer geschlossen" melden und dessen
    // Wiederanzeige-Sperre ausloesen. Der Besucher bekaeme das Rad dann
    // auch spaeter erst nach Ablauf der Sperrfrist wieder, obwohl er es nie
    // gesehen hat. security-sven, 25.09.2026.
    window.addEventListener('klaviyoForms', function (e) {
      var d = e && e.detail;
      if (!d || d.formId !== RAD_FORMULAR_ID || d.type !== 'open') return;
      try { wegnehmen(); } catch (fehler) {}
    });
  }

  function start() {
    var code = codeAusCookie();
    if (!code) return;              // kein Code: nichts anfassen

    radZurueckhalten();             // gilt auf JEDER Seite, solange der Code liegt

    if (schonGezeigt()) return;     // die Karte selbst nur einmal je Besuch
    alsGezeigtMerken();
    bauen(code);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
